/*
  Tokyo Romance Club — Footer scroll reveal.
  The footer-group's three sections (Footer links+payment, Logo,
  Utilities/policies+copyright+social) are observed independently via
  IntersectionObserver so they read as one quiet fade-up with only a
  light stagger between them (not a scattered per-element cascade). The
  outer <footer> element itself is never replaced by the theme editor's
  section-rendering, so there is nothing to re-initialize there. Once
  revealed, a group is unobserved and never re-hidden. Never runs inside
  the theme editor.
*/
(function () {
  if (window.__trcFooterMotionInit) return;
  window.__trcFooterMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var REVEAL_CLASS = 'trc-ft-in';
  var STAGGER_MS = 75;

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function init() {
    var footer = document.querySelector('footer');
    if (!footer) return;

    var targets = [];
    var footerLinks = footer.querySelector('[id$="__footer"]');
    if (footerLinks) targets.push(footerLinks);
    var logo = footer.querySelector('[id$="__logo_RVGHD7"]');
    if (logo) targets.push(logo);
    var utilities = footer.querySelector('[id$="__utilities"]');
    if (utilities) targets.push(utilities);
    if (targets.length === 0) return;

    document.documentElement.classList.add('trc-js');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .forEach(function (entry, i) {
            io.unobserve(entry.target);
            window.setTimeout(function () {
              reveal(entry.target);
            }, i * STAGGER_MS);
          });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    targets.forEach(function (target) {
      io.observe(target);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
